import React,  { useEffect } from "react"
import PropTypes from "prop-types"
import Filters from "./filters"
 import ResultsList from "./results"
 import Sort from "./sort"
import {  useRefinementList } from 'react-instantsearch';

/**
 * Category search variant component
 */

function DefaultRefinement({ attribute, defaultRefinement }) {
  const { refine, items } = useRefinementList({ attribute });

  useEffect(() => {
    if (items.length > 0) {
      // Apply default refinements only once
      defaultRefinement.forEach((value) => {
        const item = items.find((item) => item.label === value);
        if (item && !item.isRefined) {
          refine(value);
        }
      });
    }
  }, [items, refine, defaultRefinement]);

  return null; // Nothing rendered; this is for refinement only
}

function DefaultRefinementSingle({ attribute, defaultRefinement }) {
  const { refine, items } = useRefinementList({ attribute });

  useEffect(() => {
    if (items.length > 0) {
      // Apply default refinements only once
        const item = items.find((item) => item.label === defaultRefinement);
        if (item && !item.isRefined) {
          refine(defaultRefinement);
        }
    }
  }, [items, refine, defaultRefinement]);

  return null; // Nothing rendered; this is for refinement only
}
 function CategorySearch( {attribute, category} ){

    return ( <div className="search">
       
        {category.productCategory
            && <DefaultRefinement attribute="productCategories" defaultRefinement={[category.productCategory]} />
        }
        {category.applicationCategory
            && <DefaultRefinement attribute="applicationCategory" defaultRefinement={[category.applicationCategory]}  />
        }
        {category.veetApproved
            && <DefaultRefinementSingle attribute="veetApproved" defaultRefinement={'true'}  />
        }
          {category.highEfficacy
            && <DefaultRefinementSingle attribute="highEfficacy" defaultRefinement={'true'}  />
        }
        {category.productCategory
            && <Filters withBackTo={{ url: "/products", text: "Back to categories" }}  withClear  defaultAttribute="productCategories" />
        }
        {category.highEfficacy
            && <Filters withBackTo={{ url: "/products", text: "Back to categories" }}   withRangeFilter withHefficacy defaultAttribute="highEfficacy" />
        }
        {category.veetApproved
            &&  <Filters withBackTo={{ url: "/products", text: "Back to categories" }}  withVeet withRangeFilter  defaultAttribute="veetApproved" />
        }
        {category.applicationCategory
            &&  <Filters withBackTo={{ url: "/products", text: "Back to categories" }}   withRangeFilter withAppCategory withAppCategoryVal={category.applicationCategory} defaultAttribute="applicationCategory" />
        }

        <div className="search__main">
            <div className="search__header">
                <h1 className="search__heading">{category.title}</h1>
                <div className="grid">
                    <p className="grid__item lap-and-up-two-thirds search__description">
                        {category.description}
                    </p>
                    <div className="grid__item lap-and-up-one-third"><Sort category={category} /></div> 
                </div>
            </div>
            <ResultsList />
        </div>
    </div>)
}
CategorySearch.propTypes = {
 	match: PropTypes.shape({
		params: PropTypes.shape({
			category: PropTypes.string,
		}),
	})
};
export default CategorySearch